import { TFunction } from 'react-i18next';

import { getMappedTranslation } from 'utility/Translate/mappedTranslation';

import { FlightDistance } from 'types/Search/form';

const flightDistanceTranslationKeyMap: Record<FlightDistance, string> = {
    [FlightDistance.Short]:
        'TRANS-short-distance-until-two-and-a-half-hours-flight',
    [FlightDistance.Middle]:
        'TRANS-middle-distance-two-and-a-half-until-6-hours-flight',
    [FlightDistance.Long]: 'TRANS-long-distance-from-6-hours-flight',
};
const distanceWordingTranslationKeyMap: Record<FlightDistance, string> = {
    [FlightDistance.Short]: 'TRANS-short-distance-flights',
    [FlightDistance.Middle]: 'TRANS-middle-distance-flights',
    [FlightDistance.Long]: 'TRANS-long-distance-flights',
};
const distanceTranslationKeyMap: Record<FlightDistance, string> = {
    [FlightDistance.Short]: 'TRANS-flight-duration-until-two-and-a-half-hours',
    [FlightDistance.Middle]:
        'TRANS-flight-duration-from-two-and-a-half-until-6-hours',
    [FlightDistance.Long]: 'TRANS-flight-duration-from-6-hours',
};

export const getTargetDistanceLabel = (type: FlightDistance, t: TFunction) =>
    getMappedTranslation(flightDistanceTranslationKeyMap, type, t);

export const getDistanceWordingLabel = (type: FlightDistance, t: TFunction) =>
    getMappedTranslation(distanceWordingTranslationKeyMap, type, t);

export const getDistanceLabel = (type: FlightDistance, t: TFunction) =>
    getMappedTranslation(distanceTranslationKeyMap, type, t);
